import Vue from 'vue';
import { LOGOUT } from 'src/store/types';
import { mapActions } from 'vuex';
import { BfSpinner } from 'components/Butterfly';
const LogoutPage = Vue.extend({
    components: { BfSpinner },
    mounted() {
        // start logout (if not already logging out)
        this.LOGOUT({
            use_auth0: this.$route.query.use_auth0,
            returnTo: this.$route.query.returnTo,
        });
    },
    methods: {
        ...mapActions({ LOGOUT }),
    },
});
export default LogoutPage;
